<template>
  <footer class="footer-wrap">
    <p class="footer-disclaimer">{{ $t('footer.disclaimer') }}</p>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style lang="scss" scoped>
.footer-wrap {
  width: 100%;
  padding: 20px 24px;
  background-color: var(--background-primary);
  border-top: 1px solid var(--border-strength-100);
  box-sizing: border-box;
}

.footer-disclaimer {
  max-width: 960px;
  margin: 0 auto;
  color: var(--content-tertiary);
  font-size: 13px;
  line-height: 1.7;
  text-align: center;
}

@media (max-width: 768px) {
  .footer-wrap {
    padding: 16px 20px;
  }

  .footer-disclaimer {
    font-size: 12px;
    line-height: 1.6;
    text-align: left;
  }
}

@media (max-width: 480px) {
  .footer-wrap {
    padding-right: 112px;
  }
}
</style>
